import { Box, Flex, Image } from '@chakra-ui/react';
import ChakraMarkdown from '../ChakraMarkdown';
import Button from '../CustomButton';
import Link from 'next/link';

const SuccessStory = ({ item }) => {
  return (
    <Flex
      maxW={450}
      h="inherited"
      direction="column"
      justifyContent="space-between"
    >
      <Flex direction="column" justifyContent="center" alignItems="center">
        {item.attributes.logo.data ? (
          <Image
            src={item.attributes.logo.data.attributes.url}
            width={300}
            height={200}
            alt={item.attributes.company}
            objectFit="contain"
          />
        ) : (
          <Box width={300} height={200}></Box>
        )}
        <ChakraMarkdown
          content={item.attributes.shortDescription}
          onLinkClick={() => null}
        />
      </Flex>
      <Box textAlign="center" justifyContent="center" mt={10}>
        <Link
          href={`/client-success-stories/${item.attributes.url}`}
          style={{ textDecoration: 'none' }}
        >
          <Button title="See case study" backgroundColor="#CF0032" />
        </Link>
      </Box>
    </Flex>
  );
};

export default SuccessStory;
